<div class="content-container">
  @if (errorType === 'NO_REPORT') {
    <gc-icon
      [iconName]="'circleStrikeThrough'"
      [color]="'secondary'"
      [size]="'large'"
    />
    <gc-text [variant]="'smallHeading'">{{
      'signingErrorScreen.reportDoesNotExist' | translate
    }}</gc-text>
  }
  @if (errorType === 'SIGNING_NOT_AVAILABLE') {
    <gc-icon
      [iconName]="'triangleExclamation'"
      [color]="'caution'"
      [size]="'large'"
    />
    <gc-text [variant]="'smallHeading'">{{
      'signingErrorScreen.unableToStartSigning' | translate
    }}</gc-text>
    <gc-text [variant]="'supportiveHeading'">{{
      'signingErrorScreen.reportMissingData' | translate
    }}</gc-text>
    <gc-button (clicked)="handleGoToReport()">{{
      'signingErrorScreen.goToReport' | translate
    }}</gc-button>
  }
  @if (errorType === 'UNKNOWN_ERROR') {
    <gc-icon
      [iconName]="'triangleExclamation'"
      [color]="'caution'"
      [size]="'large'"
    />
    <gc-text [variant]="'smallHeading'">{{
      'signingErrorScreen.signingCouldNotBeStarted' | translate
    }}</gc-text>
    <gc-text [variant]="'supportiveHeading'">{{
      'signingErrorScreen.refreshOrTryAgain' | translate
    }}</gc-text>
    <gc-button (clicked)="handleRefreshPage()">{{
      'signingErrorScreen.refreshPage' | translate
    }}</gc-button>
  }
</div>
